import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DnIconAndTextComponent } from './dn-icon-and-text.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [DnIconAndTextComponent],
  imports: [CommonModule, MatButtonModule, MatIconModule],
  exports: [DnIconAndTextComponent],
})
export class DnIconAndTextModule {}
